const Data = [
    {
        name: "Tvisha Khakhar",
        position: "RISE Head",
        imageUrl: "/assets/images/members/Heads24/Tvisha Khakhar.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087648426543&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/tvisha-khakhar-a71547250",
        email: "tvisha@gyws.org"
    },
    {
        name: "Lokesh Saran",
        position: "RISE Head",
        imageUrl: "/assets/images/members/Heads24/Lokesh Saran.jpeg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087515113955&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/lokesh-saran-b0535925",
        email: "lokesh.saran@gyws.org"
    },
    {
        name: "Swaralipi Datta",
        position: "RISE Head",
        imageUrl: "/assets/images/members/Heads24/Swaralipi Datta.jpeg",
        facebookLink: "https://www.facebook.com/profile.php?id=100087185364901",
        linkedinLink: "https://www.linkedin.com/in/swaralipi-datta04/",
        email: "swaralipi.datta@gyws.org"
    },
]

export default Data;